<template>
  <v-settings-sidebar v-model="show">
    <!-- A selector for the classification -->
    <v-classification-selector />
    <!-- A selector for the features -->
    <v-feature-selector />
    <!-- A switch to get all the items or only the items without the atribute -->
    <v-only-missing-switch />
    <!-- A selector to filter by brands -->
    <v-brands-selector />
    <!-- A pattern to use in as the LIKE operator to search the items -->
    <v-like-pattern-input />
    <!-- The search button to perform the search -->
    <v-search-button />
    <!-- The input to set the value to map -->
    <v-feature-value-input />
    <!-- The button to save the rule and its configurations -->
    <v-save-rule-button />
  </v-settings-sidebar>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import VBrandsSelector from "./BrandsSelector";
import VClassificationSelector from "./ClassificationSelector";
import VFeatureSelector from "./FeatureSelector";
import VFeatureValueInput from "./FeatureValueInput";
import VLikePatternInput from "./LikePatternInput";
import VOnlyMissingSwitch from "./OnlyMissingSwitch";
import VSaveRuleButton from './SaveRuleButton';
import VSearchButton from "./SearchButton";
import VSettingsSidebar from "@/components/sidebars/SettingsSidebar.vue";

export default {
  components: {
    VBrandsSelector,
    VClassificationSelector,
    VFeatureSelector,
    VFeatureValueInput,
    VLikePatternInput,
    VOnlyMissingSwitch,
    VSaveRuleButton,
    VSearchButton,
    VSettingsSidebar
  },
  computed: {
    ...mapState("featureRules", ["showSidebar"]),
    show: {
      get() {
        return this.showSidebar;
      },
      set(value) {
        this.setShowSidebar(value);
      }
    }
  },
  methods: {
    ...mapMutations("featureRules", ["setShowSidebar"])
  }
};
</script>